var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconstag1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#333333C7",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#333;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333333C7",
    className: "a",
    d: "M9.04,3a1.274,1.274,0,0,0-.905.375l-5.76,5.76a1.28,1.28,0,0,0,0,1.81l1,1A2.529,2.529,0,0,1,4.03,10.79L9.79,5.03a2.542,2.542,0,0,1,1.81-.75h3.485A2.549,2.549,0,0,0,12.88,3ZM11.6,5.56a1.274,1.274,0,0,0-.905.375L4.935,11.7a1.28,1.28,0,0,0,0,1.81l5.12,5.12a1.28,1.28,0,0,0,1.81,0l5.76-5.76A1.274,1.274,0,0,0,18,11.96V8.12a2.56,2.56,0,0,0-2.56-2.56Zm3.84,1.28a1.28,1.28,0,1,1-1.28,1.28A1.28,1.28,0,0,1,15.44,6.84Z",
    transform: "translate(-2 -3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconstag1);
export default __webpack_public_path__ + "static/media/icons tag-1.83083a64a474264e317b8f41379d94fa.svg";
export { ForwardRef as ReactComponent };